import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { Spin } from "antd";
import MySegmented from "../../components/segmented/Segmented";
import RadialBarChart from "../../components/chart/RadialBarChar";
import Add from "../../assets/Add";
import { GetFileListApi } from "../../api/request/service";
import CreateFileModal from "./components/CreateFileModal";

const Files = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [segmentedValue, setSegmentedValue] = useState(
    state?.status || "unsubmitted"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileCount, setFileCount] = useState({});
  const [isCreateFileOpen, setIsCreateFileOpen] = useState(false);

  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary")
    ?.trim();

  const fileStatus = [
    {
      label: `Unsubmitted (${fileCount?.unsubmitted || 0})`,
      value: "unsubmitted",
    },
    {
      label: `In-Process Files (${fileCount?.inprocess || 0})`,
      value: "inprocess",
    },
    { label: `Closed Files (${fileCount?.closed || 0})`, value: "closed" },
  ];

  const getFileList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetFileListApi({ type: segmentedValue });
      if (data?.status) {
        setFileList(data?.data);
        setFileCount(data?.status_counts);
      }
    } catch (error) {
      setFileList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFileList();
  }, [segmentedValue]);

  return (
    <div>
      <div className="border rounded-xl p-8 flex items-center justify-around bg-White">
        <div className="h-[250px]">
          <img
            src="/assets/images/start-file-banner.png"
            alt="image"
            className="h-full object-contain"
          />
        </div>
        <div>
          <p className="title">
            Manage your tax documents with us.
          </p>
          <p className="text-secondaryLight1 mt-3">
            Enter your tax details correctly and track your progress easily as
            you move forward with your filing.
          </p>
          <button
            onClick={() => setIsCreateFileOpen(true)}
            className="btn-primary flex items-center justify-center gap-3 mt-4"
          >
            <Add />
            Start New File
          </button>
        </div>
      </div>

      <div className="mt-8">
        <MySegmented
          options={fileStatus}
          value={segmentedValue}
          setValue={setSegmentedValue}
        />

        <div>
          {isLoading ? (
            <div className="flex flex-col items-center gap-2 mt-16">
              <Spin />
              <p className="text-secondaryLight1">Loading...</p>
            </div>
          ) : (
            <div className="my-6">
              {fileList?.length ? (
                <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
                  {fileList?.map((service, index) => (
                    <div
                      key={index}
                      className="px-2 cursor-pointer "
                      onClick={() => navigate(`/file/${service?.id}`)}
                    >
                      <div className="border rounded-xl bg-white">
                        <div className="flex items-center justify-between px-4 py-2 border-b">
                          <h4>{service?.service_type?.service_name}</h4>
                          <p className="font-semibold text-Gray">
                            #{service?.file_number}
                          </p>
                        </div>
                        <div className="flex sm:flex-row flex-col items-center justify-between px-4">
                          <div className="space-y-4 py-2">
                            <div className="text-Gray">
                              <h4 className="mb-2">
                                {moment(service?.created_at).format("lll")}
                              </h4>
                            </div>
                            <div>
                              <h4 className="font-semibold mb-2">Status</h4>
                              <div className="flex items-center gap-2">
                                <button className="rounded-full bg-primary text-white text-sm font-semibold uppercase py-1 px-6">
                                  {service?.status}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-center items-center">
                            <RadialBarChart
                              values={[service?.completion_percentage]}
                              labels={["Completed"]}
                              colors={[primaryColor]}
                              value={true}
                              height={200}
                              width={150}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-secondaryLight1 text-center mt-12">
                  No files found
                </p>
              )}
            </div>
          )}
        </div>
      </div>

      <CreateFileModal
        isOpen={isCreateFileOpen}
        setIsOpen={setIsCreateFileOpen}
      />
    </div>
  );
};

export default Files;
